import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: "footer.links.spreadsheet", path: "/cssbuy-spreadsheet/" },
    { label: "footer.links.finds", path: "/cssbuy-finds/" },
    { label: "footer.links.review", path: "/cssbuy-review/" },
    { label: "footer.links.shipping", path: "/cssbuy-shipping/" },
    { label: "footer.links.coupon", path: "/cssbuy-coupon/" },
    { label: "footer.links.safety", path: "/cssbuy-safety/" },
    { label: "footer.links.blog", path: "/blog/" },
  ];

  const resourceLinks = [
    { label: "footer.resources.guides", path: "/cssbuy-tutorials/" },
    { label: "footer.resources.qc", path: "/cssbuy-qc/" },
    { label: "footer.resources.sellers", path: "/cssbuy-sellers/" },
    { label: "footer.resources.comparisons", path: "/comparisons/" },
  ];

  const legalLinks = [
    { label: "footer.legal.about", path: "/about/" },
    { label: "footer.legal.policy", path: "/editorial-policy/" },
    { label: "footer.legal.contact", path: "/contact/" },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-lg font-bold text-primary-600">CSSBuy</span>
              <span className="text-xs font-medium text-foreground-600 bg-primary-50 px-2 py-0.5 rounded-md">
                Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t("footer.desc")}
            </p>
            <p className="text-xs text-foreground-500 italic">
              {t("footer.disclaimer")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">{t("footer.links.title")}</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {t(link.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">{t("footer.resources.title")}</h3>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {t(link.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">{t("footer.legal.title")}</h3>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {t(link.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}